@if (isLoading) {
  <main class="flex min-h-[32rem] flex-1 items-center justify-center px-10 py-6 text-lWhite">
    <l-spinner />
  </main>
} @else { 
  <main class="isolate">
    <header class="pointer-events-none absolute inset-x-0 top-0 h-[72vh] overflow-hidden">
      <img
        [src]="track?.coverImageUrl"
        [alt]="track?.name"
        class="h-full w-full object-cover object-center -z-20 opacity-95 mask-fade-bottom"
      >
      <div class="pointer-events-none absolute inset-x-0 top-0 h-60 bg-gradient-to-b from-lBgDark to-transparent"></div>
    </header>

    <article class="relative z-10 mt-24 flex flex-1 flex-col px-28 pb-12 text-lWhite">
      <section class="flex justify-between h-[40vh] items-end">
        <h1 class="text-4xl font-semibold tracking-tight md:text-6xl">{{ track?.name }}</h1>

        <div class="flex items-center">
          <div class="w-10 h-9 pl-1 flex items-center justify-center rounded-l-full bg-lBlack text-lWhite">
            <l-icon class="text-lg">{{ locationIcon }}</l-icon>
          </div>

          <span class="px-3 py-2 rounded-r-full text-sm bg-lGray600 text-lWhite">
            {{ courses.length }}
          </span>
        </div>
      </section>

      <hr class="border-lWhite/10 my-12" />

      <section class="flex flex-col gap-8 px-6 lg:px-14">
        <ng-template #courseCard let-course>
          <l-course-card [course]="course" />
        </ng-template>

        <div class="flex flex-col gap-3">
          <h2 class="text-2xl font-semibold text-lWhite">Descrição</h2>
          <p class="max-w-xl text-base leading-7 text-lWhite/72">
            {{ track?.description || 'Descrição indisponível no momento.' }}
          </p>
        </div>

        <div class="flex flex-col gap-3">
          <h3 class="text-2xl font-semibold text-lWhite">Cursos</h3>

          @if (isLoadingCourses) {
            <div class="flex min-h-40 items-center justify-center">
              <l-spinner />
            </div>
          } @else if (courses.length) {
            <l-carousel [items]="courses" [itemTemplate]="courseCard"></l-carousel>
          } @else {
            <p class="text-lSecondary text-lg">Esta trilha não possui cursos.</p>
          }
        </div>
        
      </section>
    </article>
  </main>
}

